module.exports = __webpack_public_path__ + "static/dunlopdiy-00-hero-ea6a8e73562d85ee8516a9fbafce6e9c.jpg";